var map = {
	"./assets/ajinomotoWheel/wheel.png": 7410,
	"./assets/bmiValentinesDayWheel/wheel.png": 2280,
	"./assets/christmasFortuneWheel/wheel.png": 5357,
	"./assets/classicWheel/wheel.png": 7902,
	"./assets/estivalWheel/wheel.png": 9008,
	"./assets/grippleWheel/wheel.png": 3928,
	"./assets/losteWheel/wheel.png": 9393,
	"./assets/sirhaWheel/wheel.png": 1940,
	"./assets/stickAndPlayWheel/wheel.png": 4760,
	"./assets/wheel.png": 7972
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1217;